<script setup lang="ts">
import type { VNode } from "vue";

defineSlots<{
  title(): VNode;
  subtitle(): VNode;
  default?: () => VNode;
}>();

defineProps<{
  largeGap?: boolean;
}>();
</script>

<template>
  <div
    :class="[
      $attrs['class'],
      'headline',
      {
        'headline--large-gap': largeGap
      }
    ]"
  >
    <slot />
    <div class="headline__captions">
      <div class="headline__title">
        <slot name="title" />
      </div>
      <div class="headline__subtitle">
        <slot name="subtitle" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings";
@import "frontend/init/jiffy/mixin";
@import "../ArtworkQualityConfigPanel.scss";

.headline {
  display: flex;
  flex-flow: column;
  gap: 12px;
  margin-bottom: 10px;

  &--large-gap {
    gap: 36px;
  }

  &__captions {
    display: flex;
    flex-flow: column;
    gap: 4px;
  }

  &__title {
    color: $black-light;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    flex-flow: column;
    line-height: 1;

    @include with-quality-container {
      font-size: 20px;
      flex-grow: 1;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
    }
  }

  &__subtitle {
    color: $black-light;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}
</style>
